import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { GatsbyImage } from "gatsby-plugin-image";

import { FC } from "react";
import { BlockContainer, ShiIcon } from "src/atoms";
import Renderer from "src/lib/renderer";

import { Element } from "@prismicio/react";
import { heading2, heading3 } from "src/lib/renderer/elements/headings";
import paragraph from "src/lib/renderer/elements/paragraph";

const BlockTestimonial: FC<Gatsby.PageBlockTestimonialFragment> = ({
  primary,
}) => {
  if (!primary) throw Error();

  const {
    content,
    author_picture,
    author_job,
    author_name,
    has_colored_background,
  } = primary;

  return (
    <BlockContainer>
      <Box
        bg={has_colored_background ? "secondary-green-50" : "transparent"}
        borderRadius="intermediate"
        p={{
          base: has_colored_background ? "space-24" : 0,
          md: has_colored_background ? "space-80" : 0,
        }}
        w="full"
      >
        <Box maxWidth="750px" mx="auto">
          <Box>
            <ShiIcon
              name="quotationmark"
              width="40px"
              height="30px"
              marginBottom="space-24"
              fill={has_colored_background ? "#003725" : "#262626"}
              sx={{
                path: {
                  fill: has_colored_background ? "#003725" : "#262626",
                },
              }}

            />

            <Text as="div" >
              <Renderer
                overrides={{
                  [Element.heading2]: (args) =>
                    heading3({
                      ...args,

                    }),
                  [Element.paragraph]: (args) =>
                    paragraph({
                      ...args,
                      overrideProps: {
                        variant: "body-md-reg"
                      },
                    }),
                }}
                field={content}
              />
              {author_name && (
                <Text as="div" variant="body-md-reg">
                  <Center flexDirection={{ base: "column", sm: "row" }}>
                    <Flex alignItems="center">
                      {author_picture?.document?.__typename ===
                        "PrismicElementImage" && (
                          <Box
                            as={GatsbyImage}
                            boxSize="32px"
                            borderRadius="full"
                            overflow="hidden"
                            isolation="isolate" //required to fix safari ui bug
                            image={
                              author_picture.document.data?.image_file
                                ?.gatsbyImageData
                            }
                            alt={
                              author_picture.document.data?.image_file?.alt ?? ""
                            }
                          />
                        )}

                      <Text as="span" marginLeft="space-8" >
                        {author_name}
                      </Text>
                    </Flex>

                    <Text
                      as="span"
                      display={{ base: "none", sm: "initial" }}
                      marginX="space-8"
                    >
                      {"-"}
                    </Text>

                    {author_job}
                  </Center>
                </Text>
              )}
            </Text>
          </Box>
        </Box>
      </Box>
    </BlockContainer>
  );
};

export default BlockTestimonial;
